/**
 * Damage checks — Yes means damage was found. Not rendered for a sealed box
 * (see InspectionPanel).
 */

import React from 'react';

import { ChecklistSection, type ChecklistSectionProps } from './ChecklistSection';

export const DamageSection: React.FC<ChecklistSectionProps> = props => (
  <ChecklistSection hint="Tap Yes where there's damage, and add a note describing it." {...props} />
);
